Ext.define('SA.lq.edit.LocationRadioList', {
    constructor({listCmp, createLabelHtml}) {
        this.listCmp = listCmp;
        this.createLabelHtml = createLabelHtml;
    },

    createRadio() {
        return {
            xtype: 'sa-radio',
            boxLabel: '&nbsp;', 
            cls: 'sa-edit-check-field',
            encodeBoxLabel: false,
            listeners: {change: this.onRadioSelect, scope: this}
        };
    },

    getRadios() {
        return this.listCmp.query('sa-radio');
    },

    onRadioSelect(radio) {
        this.getRadios().filter(someRadio => someRadio !== radio).forEach(otherRadio => otherRadio.deselect());

        this.selectHandler(radio.locationStringId);
    },

    scrollIntoViewRadioWithLocationStringId(locationStringId) {
        var radio = this.getRadios().find(radio => radio.locationStringId === locationStringId);

        if (radio) {
            radio.el.dom.scrollIntoView({block: 'nearest'});
        }
    },

    setSelectHandler(selectHandler) {
        this.selectHandler = selectHandler;
    },

    setState(state) {
        var radios = this.getRadios(),
            radioCount = radios.length,
            selectableLocationStringIds = state.getSelectableLocations().map(location => location.getStringId()),
            selectedLocationStringId = state.getSelectedLocationStringId(),
            requiredRadioCount = selectableLocationStringIds.length;

        if (requiredRadioCount > radioCount) {
            this.listCmp.add(selectableLocationStringIds.slice(radioCount).map(() => this.createRadio()));
        }
        else if (radioCount > requiredRadioCount) {
            this.listCmp.remove(radios.slice(requiredRadioCount));
        }

        this.getRadios().forEach((radio, idx) => {
            var locationStringId = selectableLocationStringIds[idx],
                labelHtml = this.createLabelHtml(locationStringId),
                isSelected = locationStringId === selectedLocationStringId;

            radio.locationStringId = locationStringId;
            radio.setLabelHtml(labelHtml);
            radio.setSelected(isSelected);
        });
    }
});
